import { assertEvent } from 'xstate';
import { ActionEventParams } from '../../../../../apply/lib/types';
import { FraudAlloyContext } from './fraudAlloyMachine';
import {
  FraudAlloyMachineEvents,
  SendStartIDUploadJourneyParams,
} from './types/events';
import { StartIDUploadJourneyResult } from './types/actors';

/**
 * Gets input for start ID upload journey actor
 * @param ActionEventParams<FraudAlloyContext,FraudAlloyMachineEvents>
 * @returns SendStartIDUploadJourneyParams
 */
export const getStartIDUploadJourneyInput = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  FraudAlloyMachineEvents
>): SendStartIDUploadJourneyParams => {
  assertEvent(event, 'SEND_START_ID_UPLOAD_JOURNEY');

  return event.params;
};

/**
 * Gets input for poll ID upload journey status actor
 * @param ActionEventParams<FraudAlloyContext,FraudAlloyMachineEvents>
 * @returns StartIDUploadJourneyResult
 */
export const getPollIDUploadJourneyStatusInput = ({
  event,
}: ActionEventParams<
  FraudAlloyContext,
  FraudAlloyMachineEvents
>): StartIDUploadJourneyResult => {
  if ('output' in event) {
    return event.output as StartIDUploadJourneyResult;
  }

  throw new Error('Event does not contain output');
};
